import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Account from '@/views/Account'
import Contact from '@/views/Contact'
import CreateAccount from '@/views/CreateAccount'
import Detail from '@/views/Detail.vue'
import HydroAgreement from '@/views/HydroAgreement.vue'
import Map from '@/views/Map.vue'
import ParticipationAgreement from '@/views/ParticipationAgreement.vue'
import Summary from '@/views/Summary.vue'
import Thankyou from '@/views/Thankyou.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/account',
        name: 'Account',
        component: Account
    },
    {
        path: '/contact',
        name: 'Contact',
        component: Contact
    },
    {
        path: '/createaccount',
        name: 'CreateAccount',
        component: CreateAccount
    },
    {
        path: '/detail',
        name: 'Detail',
        component: Detail
    },
    //  {
    //    path: '/detail',
    //    name: 'Detail',
    //    // route level code-splitting
    //    // this generates a separate chunk (about.[hash].js) for this route
    //    // which is lazy-loaded when the route is visited.
    //    component: () => import(/* webpackChunkName: "about" */ '../views/Detail.vue')
    //},
    {
        path: '/hydroagreement/:data?',
        name: 'HydroAgreement',
        component: HydroAgreement
    },
    {
        path: '/map',
        name: 'Map',
        component: Map
    },
    {
        path: '/participationagreement/:data?',
        name: 'ParticipationAgreement',
        component: ParticipationAgreement
    },
    {
        path: '/summary',
        name: 'Summary',
        component: Summary
    },
    {
        path: '/thankyou',
        name: 'Thankyou',
        component: Thankyou
    }
]

const router = new VueRouter({
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 }
    }
})

export default router
